import React from 'react';
import { connect } from 'react-redux';

import { DataLoader } from '../../components/common';
import { LoadState } from '../../components/common/data-loader/data-loader';
import { loadCommonDataForFileManagerRoute } from '../../redux/actions/router/file-manager';
import { RouterContext } from '../../types/router';

import { FileManagerLazyContainer } from './file-manager.lazy';

interface Props {
  router?: any;
  loadCommonDataForFileManagerRoute(router: RouterContext): any; // Promise<any>
}

class FileManagerCommonDataLoader extends React.PureComponent<Props> {
  private loadCommonData(): Promise<any> {
    const { loadCommonDataForFileManagerRoute, router } = this.props;

    return loadCommonDataForFileManagerRoute(router);
  }

  public render() {
    return (
      <DataLoader loadData={this.loadCommonData.bind(this)}>
        {(props: LoadState) => <FileManagerLazyContainer {...props} />}
      </DataLoader>
    );
  }
}

const mapStateToProps = null;

const mapDispatchToProps = {
  loadCommonDataForFileManagerRoute,
};

export const FileManager = connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(FileManagerCommonDataLoader);
